import React from 'react';
import Sidebar from '../Sidebar';
import Dashboard from '../Dashboard';
import SettingsMain from './SettingsMain'

export default function Settings() {
    return (
        <div>
            <Dashboard cmp={<SettingsMain />} />
        </div>
    )
}

